export function getModifiedItemNameFromItem(item) {
  // @todo. auto generated. fix this error
  // @ts-ignore
  return item.modifiedProductName || item.name;
}